export const historyAccessMessage = (error) => {
  if (error?.status === 401) return 'Sign in again to view order history.';
  if (error?.status === 403) return 'You do not have access to this history.';
  return null;
};
